import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

// firebase init - add your own config here
const firebaseConfig = {
  apiKey: "AIzaSyBJJMI7QMnLG3GgKZc-jZhbV946oSDcWMc",
  authDomain: "smart-menu-a2427.firebaseapp.com",
  databaseURL: "https://smart-menu-a2427.firebaseio.com",
  projectId: "smart-menu-a2427",
  storageBucket: "smart-menu-a2427.appspot.com",
  messagingSenderId: "51515523744",
  appId: "1:51515523744:web:07880610ba364bb1177fc5",
  measurementId: "G-5ZGT3KLN1Q",
};
firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();
const { TimeStamp, GeoPoint } = firebase.firestore;
firebase
  .firestore()
  .enablePersistence()
  .then(() => {
    const firestore = app.firestore();
    // Use Cloud Firestore ...
  });
//db.enablePersistence({ synchronizeTabs: true });

// collection references

// export utils/refs
export { db, auth, firebase, TimeStamp, GeoPoint };
